import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

// Helper function to call Firebase Cloud Functions
const callCloudFunction = async (functionName, data) => {
  try {
    const functionRef = httpsCallable(functions, functionName);
    const result = await functionRef(data);
    return result.data;
  } catch (error) {
    console.error(`Error calling ${functionName}:`, error);
    throw error;
  }
};

// Create or update contact
export const createOrUpdateContact = async (contactData) => {
  try {
    const { firstName, lastName, email, phone, shortCode, tagName } = contactData;
    
    const result = await callCloudFunction('createUpdateContact', {
      email,
      firstName,
      lastName,
      phone,
      shortCode,
      tagName
    });
    
    return result;
  } catch (error) {
    console.error('Failed to create or update contact:', error);
    throw error;
  }
};

// Update contact custom fields (for metrics)
export const updateContactCustomFields = async (contactId, updates) => {
  try {
    const { mentalResilience, optimalPace, shortCode } = updates;
    
    const result = await callCloudFunction('updateCustomFields', {
      contactId,
      mentalResilience,
      optimalPace,
      shortCode
    });
    
    return result;
  } catch (error) {
    console.error('Error updating contact custom fields:', error);
    throw error;
  }
};

// Add tag to contact
export const addContactTag = async (contactId, tagId, tagName) => {
  try {
    const result = await callCloudFunction('addTag', {
      contactId,
      tagId,
      tagName
    });
    
    return result;
  } catch (error) {
    console.error('Error adding tag to contact:', error);
    throw error;
  }
};

// Find tag by name
export const findTagByName = async (tagName) => {
  try {
    const result = await callCloudFunction('findTag', { tagName });
    return result;
  } catch (error) {
    console.error('Error finding tag by name:', error);
    throw error;
  }
};

// Health check
export const checkHealth = async () => {
  try {
    const result = await callCloudFunction('health');
    return result;
  } catch (error) {
    console.error('Error checking health:', error);
    throw error;
  }
};

export default {
  createOrUpdateContact,
  updateContactCustomFields,
  addContactTag,
  findTagByName,
  checkHealth
};
